<template>
  <AppSelect
    ref="appSelectTag"
    popup-content-class="app-select-tag__popup"
    :class="['app-select-tag', { 'is-open': isOpen }]"
    multiple
    use-chips
    v-bind="$attrs"
    @blur="$emit('blur', $event)"
    @clear="$emit('clear', $event)"
    @click="$emit('click', $event)"
    @focus="$emit('focus', $event)"
    @input="$emit('input', $event)"
    @popup-hide="isOpen = false"
    @popup-show="isOpen = true"
  >
    <template #before-options>
      <div class="app-select-tag__new-option">
        <AppInput
          v-model="newOption"
          @keyup.enter="addOption"
        />
        <AppButton
          icon-right="fa-regular fa-circle-check"
          class="text-14-400"
          text-color="black"
          padding="8px 10px"
          :disabled="!newOption"
          @click="addOption"
        />
      </div>
    </template>
    <template v-slot:no-option>
      <div class="app-select-tag__new-option">
        <AppInput
          v-model="newOption"
          @keyup.enter="addOption"
        />
        <AppButton
          icon-right="fa-regular fa-circle-check"
          class="text-14-400"
          text-color="black"
          padding="8px 10px"
          @click="addOption"
        />
      </div>
    </template>
    <template v-slot:selected-item="scope">
      <q-chip
        removable
        icon-remove="fa-solid fa-xmark"
        :tabindex="scope.tabindex"
        class="chip-option"
        color="grey-3"
        text-color="black"
        @remove="scope.removeAtIndex(scope.index)"
      >
        {{ scope.opt }}
      </q-chip>
    </template>
    <template v-slot:option="scope">
      <div
        class="app-select-tag__option"
        v-on="scope.itemEvents"
      >
        <div class="app-select-tag__option-inner">
          <div class="app-select-tag__option-label">
            {{ scope.opt }}
          </div>
        </div>
      </div>
    </template>
  </AppSelect>
</template>

<script>
import AppInput from 'common/components/AppInput';
import AppSelect from 'common/components/AppSelect';
import AppButton from 'common/components/buttons/AppButton';

export default {
  name: 'AppSelectTag',
  components: {
    AppInput,
    AppButton,
    AppSelect,
  },
  data() {
    return {
      newOption: undefined,
      isOpen: false,
    };
  },
  methods: {
    addOption() {
      if (!this.newOption) {
        return;
      }
      this.$refs.appSelectTag.add(this.newOption, true);
      this.newOption = undefined;
    },
  },
};
</script>

<style lang="scss">
.app-select-tag {
  &_empty {
    .q-field__control-container {
      align-items: baseline;
    }
  }

  .q-field__native {
    gap: 5px;
  }
  &.is-open {
    .q-field--outlined {
      .q-field__control {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        transition: all 0.5ms ease;
        &:before,
        &:after {
          border-color: $grey-2 !important;
        }
      }
    }
  }
  &__option {
    display: flex;
    gap: 10px;
    padding: 0 10px;
    cursor: pointer;

    &:hover {
      background: $grey-6;
    }

    &-inner {
      display: flex;
      gap: 6px;
      font-size: 14px;
      font-weight: 400;
      padding: 8px 0;
      border-top: 1px solid $grey-2;
      flex: 1;
    }

    &-label {
      background: $grey-6;
      border-radius: 10px;
      padding: 6px 15px;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  &__new-option {
    display: flex;
    gap: 10px;
    padding: 10px;
    max-width: fit-content;

    .app-input {
      flex: 1;
      .q-field__control {
        height: 40px !important;
      }
    }

    .q-btn {
      .q-icon {
        margin: 0;
      }
    }
  }
}
.app-select-tag__popup {
  box-shadow: none;
  border: 1px solid $grey-2;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-top: none;
}
</style>
